module.exports =
  SHIFT_TYPES: ['night', 'day', 'morning']